import { gql } from '../__generated__';

export const UPDATE_REQUIREMENTS = gql(`
  mutation UpdateRequirements($kioskId: String!, $accessGrantId: String!, $requirementArgsList: [CustomRequirementUpdateInput!]!) {
    updateRequirements(kioskId: $kioskId, accessGrantId: $accessGrantId, requirementArgsList: $requirementArgsList) {
      success
    }
  }  
`);
